import useAPI from '@/pages/members/hooks/useAPI';
import { LeadSourceRepository } from '@/repositories/members/LeadSourceRepository';

import { ONBOARDING_QUERY_KEY_PREFIX } from '../pages/Onboarding/components/Stepper';

export const useLeadSources = () => {
  const leadSourceRepository = LeadSourceRepository();

  return useAPI({
    queryKey: [ONBOARDING_QUERY_KEY_PREFIX, 'leadSources'],
    queryFn: leadSourceRepository.list,
    refetchOnWindowFocus: false
  });
};
